import React, { memo, useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// styles
import "./style.scss";

// antd component
import { Form, Radio, Button } from "antd";
// utils
import { getAbsenceTypeLabel } from "utils/helpers/helper.generateData";
import _local from "utils/localStorageUtils";

function AbsenceTypeForm({
  formData,
  isEdit,
  isNew,
  // actions
  nextStep,
  prevStep,
  goToStep,
  result,
  role,
  // default
  className,
}) {
  const childClassName = classNames("form-communication", className);
  const { t, i18n } = useTranslation();

  const localUser = _local.getLocalUser();

  const [isDisabled, setIsDisabled] = useState(true);

  const [isChildAbs, setIsChildAbs] = useState(
    !isNew && (!!isEdit?.origin || !!formData?.origin),
  );

  const [AbsFormType] = Form.useForm();

  /*
   * Check current form data from parent
   * Set old data to the form
   */
  useEffect(() => {
    if (formData && formData?.type) {
      AbsFormType.setFieldsValue(formData);
      setIsDisabled(false);

      if (!isNew && !!formData?.origin) {
        setIsChildAbs(!!formData?.origin);
      }
    } else {
      setIsChildAbs(false);
    }
  }, [formData]);

  const onFinish = values => {
    !!result && result(values);
    if (values?.type == "medical" && role == "parent") {
      !!goToStep && goToStep(3); // go to duration step
    } else {
      !!nextStep && nextStep();
    }
    AbsFormType.resetFields();
  };

  const getOpions = useCallback(() => {
    let options = [
      {
        key: "sickness",
        value: "sickness",
        label: (
          <>
            <span
              className="label__title"
              style={{ textTransform: "capitalize" }}
            >
              {getAbsenceTypeLabel("sickness")}
            </span>
            <span className="label__description">
              {t("absences.newAbsTypeOptions.sickness")}
            </span>
          </>
        ),
      },
      {
        key: "medical",
        value: "medical",
        label: (
          <>
            <span
              className="label__title"
              style={{ textTransform: "capitalize" }}
            >
              {getAbsenceTypeLabel("medical")}
            </span>
            <span className="label__description">
              {t("absences.newAbsTypeOptions.medical")}
            </span>
          </>
        ),
      },
      {
        key: "no-medical",
        value: "no-medical",
        label: (
          <>
            <span
              className="label__title"
              style={{ textTransform: "capitalize" }}
            >
              {getAbsenceTypeLabel("no-medical")}
            </span>
            <span className="label__description">
              {t("absences.newAbsTypeOptions.noMedical")}
            </span>
          </>
        ),
      },
    ];

    // TODO: show only for teacher
    if (localUser?.role == "teacher") {
      options.push({
        key: "unjustified",
        value: "unjustified",
        label: (
          <>
            <span
              className="label__title"
              style={{ textTransform: "capitalize" }}
            >
              {getAbsenceTypeLabel("unjustified")}
            </span>
            <span className="label__description">
              {t("absences.newAbsTypeOptions.unjustified")}
            </span>
          </>
        ),
      });
    }
    
    return options;
  }, [i18n?.language, localUser?.role, localUser?._id]);



  return (
    <div className={childClassName}>
      <Form
        form={AbsFormType}
        className="form-communication__form"
        name="form_absence_type"
        initialValues={{}}
        onFinish={onFinish}
        onValuesChange={() => setIsDisabled(false)}
      >
        <Form.Item name="type">
          <Radio.Group
            className="radio-group radio-group--big"
            options={getOpions()}
            optionType="Radio"
            disabled={!!isChildAbs}
          />
        </Form.Item>

        <div className="absence-actions-wrapper">
          <Button
            className="next-btn"
            form="form_absence_type"
            htmlType="submit"
            disabled={isDisabled}
          >
            {t("common.next")}
          </Button>
        </div>
      </Form>
    </div>
  );
}

AbsenceTypeForm.defaultProps = {};
AbsenceTypeForm.propTypes = {
  result: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
};

export default memo(AbsenceTypeForm);
